import { resolveVersion, versions } from 'utils/versioning';

const fieldPrefix = resolveVersion({
  [versions.alpha]: 'Alpha',
  [versions.global]: 'GRG',
  [versions.west]: 'GRG',
});

export { fieldPrefix };
